import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '@tribeplatform/react-ui-kit/Card';
export const CollectionCard = ({ collection, fields = [], }) => {
    if (!fields.length) {
        fields = ['name', 'description'];
    }
    return (React.createElement(Card, { className: "h-full" },
        React.createElement(Link, { to: "#" },
            React.createElement("div", { className: "flex-1 flex flex-col mb-2 p-6 pt-4 items-center text-center" }, fields.map(field => {
                switch (field) {
                    case 'name':
                        return (React.createElement("h3", { className: "text-content text-sm font-medium max-w-full truncate mb-2" }, collection === null || collection === void 0 ? void 0 : collection.name));
                    case 'description':
                        return (React.createElement("div", { className: "text-content-subdued text-sm max-w-full truncate" }, collection === null || collection === void 0 ? void 0 : collection.description));
                    default:
                        return null;
                }
            })))));
};
//# sourceMappingURL=CollectionCard.js.map